(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["top-bar"] && !Shopify.designMode) return;
  try {
    
  const syncTopbarSwiperHeight = () => {
    const root = document.querySelector('#topbar slide-section');
    if (!root) return;

    const activeSlide = root.querySelector('.swiper-slide-active') || root.querySelector('.swiper-slide');
    if (!activeSlide) return;

    const slideHeight = Math.ceil(activeSlide.getBoundingClientRect().height);
    if (!slideHeight) return;

    root.style.height = `${slideHeight}px`;
    root.style.maxHeight = `${slideHeight}px`;
    root.style.overflow = 'hidden';

    const swiperEl = root.classList.contains('swiper') ? root : root.querySelector('.swiper');
    if (swiperEl) {
      swiperEl.style.height = `${slideHeight}px`;
      swiperEl.style.maxHeight = `${slideHeight}px`;
      swiperEl.style.overflow = 'hidden';
    }

    const topBar = document.querySelector('.section-top-bar');
    if (topBar) {
      document.body.style.setProperty('--height-topbar', `${topBar.clientHeight}px`);
    }
  };

  const bindTopbarSwiper = () => {
    const root = document.querySelector('#topbar slide-section');
    if (!root || root.dataset.topbarBound === 'true') return;

    if (root.globalSlide) {
      root.dataset.topbarBound = 'true';
      root.globalSlide.on('init', syncTopbarSwiperHeight);
      root.globalSlide.on('slideChange', syncTopbarSwiperHeight);
      root.globalSlide.on('slideChangeTransitionEnd', syncTopbarSwiperHeight);
      root.globalSlide.on('resize', syncTopbarSwiperHeight);
      syncTopbarSwiperHeight();
      return;
    }

    setTimeout(bindTopbarSwiper, 120);
  };

  bindTopbarSwiper();
  window.addEventListener('load', () => {
    bindTopbarSwiper();
    syncTopbarSwiperHeight();
  });
  window.addEventListener('resize', syncTopbarSwiperHeight);
  setTimeout(() => {
    bindTopbarSwiper();
    syncTopbarSwiperHeight();
  }, 500);

  } catch(e) { console.error(e); }
})();
})();
